import React, { useContext, useEffect, useState } from "react";
import CourseDetails from "../../Templates/Courses/CourseDetails/CourseDetails";
import { courseURL } from "../../Hooks/URL";
import useFetch from "../../Hooks/useFetch";
import useDelete from "../../Hooks/useDelete";
import { useParams } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";

function CourseDetailsPage() {
  const { contextData, setContextData } = useContext(userContext);
  let { id } = useParams();

  const url = `${courseURL}/${id}`;
  const page = "programs";

  const [course, setCourse] = useState({});
  const [lessons, setLessons] = useState([]);
  const { data, loading, error } = useFetch(url);
  const {
    data: lessonsData,
    loading: lessonsLoading,
    error: lessonsError,
  } = useFetch(`${courseURL}/${id}/lessons`);

  const [go, setGo] = useState(false);
  const { deleteRes } = useDelete(url, go, page);

  useEffect(() => {
    if (!loading && !error && data) {
      setCourse(data?.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    if (!lessonsLoading && !lessonsError && lessonsData) {
      setLessons(lessonsData?.data);
    }
  }, [lessonsData, lessonsLoading, lessonsError]);

  useEffect(() => {
    setContextData({ ...contextData, page: "programs", data: course?.title });
  }, [course]);

  return (
    <CourseDetails
      course={course}
      setCourse={setCourse}
      url={url}
      setGo={setGo}
      loading={loading}
      lessons={lessons}
    />
  );
}

export default CourseDetailsPage;
